"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MergeStylesShadowRootProvider = exports.MergeStylesShadowRootContext = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var merge_styles_1 = require("@fluentui/merge-styles");
var useMergeStylesHooks_1 = require("../hooks/useMergeStylesHooks");
exports.MergeStylesShadowRootContext = React.createContext(undefined);
/**
 * Context for a shadow root.
 */
var MergeStylesShadowRootProvider = function (_a) {
    var shadowRoot = _a.shadowRoot, props = tslib_1.__rest(_a, ["shadowRoot"]);
    var value = React.useMemo(function () {
        return {
            stylesheets: new Map(),
            shadowRoot: shadowRoot,
        };
    }, [shadowRoot]);
    return (React.createElement(exports.MergeStylesShadowRootContext.Provider, tslib_1.__assign({ value: value }, props),
        React.createElement(GlobalStyles, null),
        props.children));
};
exports.MergeStylesShadowRootProvider = MergeStylesShadowRootProvider;
var GlobalStyles = function (props) {
    var useAdoptedStylesheet = (0, useMergeStylesHooks_1.useMergeStylesHooks)().useAdoptedStylesheet;
    useAdoptedStylesheet(merge_styles_1.GLOBAL_STYLESHEET_KEY);
    return null;
};
//# sourceMappingURL=MergeStylesShadowRootContext.js.map